import { createSlice } from "@reduxjs/toolkit";


const metaSlice = createSlice({
    name: 'Meta',
    initialState: {
        meta: {},
        metaList: [],
        loading: false,
        error: null,
        isMetaCreated: false,
        isMetaUpdated: false,
        isMetaDeleted: false,
    },
    reducers: {
        metaRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        metaSuccess(state, action) {
            return {
                ...state,
                loading: false,
                meta: action.payload
            }
        },
        metaFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        metaAllRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        metaAllSuccess(state, action) {
            return {
                ...state,
                loading: false,
                metaList: action.payload
            }
        },
        metaAllFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        newMetaRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        newMetaSuccess(state, action) {
            return {
                ...state,
                loading: false,
                meta: action.payload,
                isMetaCreated: true
            }
        },
        newMetaFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
                isMetaCreated: false
            }
        },
        updateMetaRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        updateMetaSuccess(state, action) {
            return {
                ...state,
                loading: false,
                meta: action.payload,
                isMetaUpdated: true
            }
        },
        updateMetaFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },
        deleteMetaRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        deleteMetaSuccess(state, action) {
            return {
                ...state,
                loading: false,
                meta: action.payload,
                isMetaDeleted: true
            }
        },
        deleteMetaFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },
        clearMeta(state, action) {
            return {
                ...state,
                meta: {},
                isMetaCreated: false,
                isMetaUpdated: false,
                isMetaDeleted: false,
            }
        },
        clearError(state, action) {
            return {
                ...state,
                error: null
            }
        },
    }
});

const { actions, reducer } = metaSlice;

export const {
    metaRequest,
    metaSuccess,
    metaFail,
    metaAllRequest,
    metaAllSuccess,
    metaAllFail,
    newMetaFail,
    newMetaSuccess,
    newMetaRequest,
    updateMetaFail,
    updateMetaRequest,
    updateMetaSuccess,
    deleteMetaRequest,
    deleteMetaSuccess,
    deleteMetaFail,
    clearMeta,
    clearError
} = actions;

export default reducer;
